import { proxy } from "valtio";

const enjoySettings = proxy({
  logo: "enjoy",
  package: "enjoy",
  devMode: false,
  stagingIds: true,
  flash: null,
  fullScreen: false,
  optionIndexPanelOpen: false,
  intro: true,
  // pages: [
  //   { link: "sidePanels", name: "Sides" },
  //   { link: "topPanel", name: "Top Panel" },
  //   { link: "ribs", name: "Ribs" },
  //   { link: "raceNumber", name: "Race Number" },
  //   { link: "topLogo", name: "Top Logo" },
  //   { link: "sideLogo", name: "Side Logo" },
  //   { link: "sealant", name: "Sealant" },
  //   { link: "confirm", name: "Confirm" },
  // ],
  steps: [
    { link: "sidePanels", name: "Sides" },
    { link: "topPanel", name: "Top Panel" },
    { link: "ribs", name: "Ribs" },
    { link: "raceNumber", name: "Race Number" },
    { link: "topLogo", name: "Top Logo" },
    { link: "sideLogo", name: "Side Logo" },
    { link: "sealant", name: "Sealant" },
    { link: "confirm", name: "Confirm" },
  ],
  currentStep: 0,
  // optionPage: 0,
  // settings: {
  //   topPanelSwatches: "colors",
  //   sidePanelMode: "regular",
  // },
  initialChoices: {
    popupSize: "31.25rem",
    activeSeat: null,
    threeDModel: "null",
    type: { index: null, name: "Select your Bike Type" },
    make: { index: null, name: "Select your Bike Type First", abrv: "" },
    model: { index: null, name: "Select your Make First" },
    year: { index: null, name: "Select your Model First" },
    topLogo: { mode: "enjoy", name: "EnjoyMfg", abrv: "ENJ" },
    sideLogos: { mode: "enjoy", name: "EnjoyMfg", abrv: "ENJ" },
    inhouseCode: null,
    logoSize: null,
    ribLimit: 6,
    confirmButtonText: "Start Customizing Your Seat!",
  },
  choices: {
    topPanel: {
      modes: [],
      selected: { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
    },
    sidePanels: {
      modes: [
        {
          mode: "regular",
          name: "Regular",
          choices: "colors",
          modeMethod: "regularSides",
        },
        {
          mode: "reinforced",
          name: "Reinforced",
          price: 9.95,
          choices: "patterns",
          modeMethod: "reinforcedSides",
        },
      ],
      selected: { mode: "regular", name: "White", hex: "#F5F5F5", abrv: "WHT" },
    },
    midPanels: {
      settings: [
        { name: "regular", choices: "colors" },
        { name: "reinforced", choices: "patterns" },
      ],
      selected: { name: "White", hex: "#ddd", abrv: "WHT" },
    },
    ribs: {
      settings: {},
      modes: [
        { mode: "no", name: "No Ribs", price: 0 },
        { mode: "single", name: "Ribs", price: 10 },
        {
          mode: "multiple",
          name: "Multicolor Ribs",
          price: 10,
          altText: "Change Ribs",
          modeMethod: "multiribs",
        },
      ],
      selected: {
        mode: "no",
        rib: [
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
          { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
        ],
      },
    },
    topLogo: {
      modes: [
        // { mode: "none", name: "None" },
        { mode: "enjoy", name: "EnjoyMfg", abrv: "ENJ" },
        { mode: "hex", name: "Hex", abrv: "HEXA" },
      ],
      selected: { mode: "enjoy", name: "EnjoyMfg", abrv: "ENJ" },
    },
    sideLogos: {
      mode: "true",
      selected: { mode: "none", name: "None", abrv: "None" },
    },
    sealant: {
      modes: [
        { mode: "no", name: "No Sealant" },
        { mode: "sealant", name: "Sealant", price: 23 },
      ],
      selected: {
        mode: "no",
        name: "No Sealant",
      },
      message: "Please allow 1-5 days for sealed seats to ship.",
    },
    raceNumber: {
      modes: [
        { mode: "none", name: "No Number" },
        {
          mode: "number",
          name: "Add Race Number",
          price: 9.95,
          altText: "Change Number",
          modeMethod: "raceNumber",
        },
      ],
      selected: {
        mode: "none",
        // mode: "number",
        name: "white",
        outlineName: "black",
        // number: "",
        number: "",
        hex: "#f5f5f5",
        outlineHex: "#111111",
        font: "hauser",
      },

      //       {
      //   shortname: "hauser",
      //   filename: "hauser",
      //   visiblename: "Hauser",
      //   family: "hauser",
      //   size: "small",
      // },
      // {
      //   shortname: "draco",
      //   filename: "draco",
      //   visiblename: "Draco",
      //   family: "draco",
      //   size: "large",
      // },
      // {
      //   shortname: "helvetica",
      //   filename: "helvetica",
      //   visiblename: "Helvetica",
      //   family: "helvetica",
      //   size: "small",
      // },
      // {
      //   shortname: "padaloma",
      //   filename: "padaloma",
      //   visiblename: "Padaloma",
      //   family: "padaloma",
      //   size: "medium",
      // },
    },
    confirm: {
      modes: [],
      selected: {},
    },
  },
  colors: [
    { name: "Black", hex: "#0F0F0F", src: null, abrv: "BLK" },
    { name: "Silver", hex: "#B5B1BA", src: null, abrv: "SIL" },
    { name: "Grey", hex: "#6c6b6a", src: null, abrv: "GRY" },
    { name: "Florescent green", hex: "#79FC3F", src: null, abrv: "FLGRN" },
    { name: "Green", hex: "#7CD133", src: null, abrv: "GRN" },
    { name: "Mint", hex: "#6CF1F5", src: null, abrv: "MNT" },
    { name: "Light Blue", hex: "#03c4fc", src: null, abrv: "LTBLU" },
    { name: "TM Blue", hex: "#1683ff", src: null, abrv: "TMBLU" },
    { name: "Yamaha Blue", hex: "#0F05B7", src: null, abrv: "BLU" },
    { name: "KTM Blue", hex: "#1d1b5c", src: null, abrv: "KTMBLU" },
    { name: "Purple", hex: "#A927F8", src: null, abrv: "PURP" },
    // { name: "Purple", hex: "#f827a9", src: null, abrv: "PURP" },
    { name: "Maroon", hex: "#72061f", src: null, abrv: "MRN" },
    { name: "Red", hex: "#ee150e", src: null, abrv: "RED" },
    { name: "Bright Red", hex: "#fd3617", src: null, abrv: "BRRED" },
    { name: "Orange", hex: "#f57b06", src: null, abrv: "ORG" },
    { name: "Pink", hex: "#ff02d3", src: null, abrv: "PNK" },
    { name: "Bright Yellow", hex: "#FEE640", src: null, abrv: "BRYELLOW" },
    { name: "Gold Yellow", hex: "#ffb600", src: null, abrv: "GOLD" },
    { name: "Yellow", hex: "#FADB2E", src: null, abrv: "YELL" },
    { name: "Neon Yellow", hex: "#E5FF1A", src: null, abrv: "NEYELL" },
    { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
    { name: "Checker", src: "checker", abrv: "CHEC" },
    { name: "Houndstooth", src: "houndstooth", abrv: "HSTH" },
    { name: "Jungle Camo", src: "junglecamo", abrv: "JCAMO" },
    { name: "Desert", src: "desert", abrv: "DCAMO" },
    { name: "Neon Yellow Bolt", src: "neonyellowbolt", abrv: "NEYELLBLT" },
    { name: "Neon Blue Techno", src: "neonbluetechno", abrv: "BTEC" },
    { name: "Aloha", src: "aloha", abrv: "ALO" },
    { name: "Leopard", src: "leopard", abrv: "LEO" },
    // { name: "Serape", src: "serape", abrv: "SER" },
  ],
  reinforcedColors: [
    { name: "Black", hex: "#0F0F0F", src: null, abrv: "BLK" },
    { name: "Blue", hex: "#0F05B7", src: null, abrv: "BLU" },
    { name: "Red", hex: "#ee150e", src: null, abrv: "RED" },
  ],
  numberColors: [
    { name: "Black", hex: "#0F0F0F", src: null, abrv: "BLK" },
    { name: "Silver", hex: "#9e9da7", src: null, abrv: "SIL" },
    { name: "Grey", hex: "#9895a0", src: null, abrv: "GRY" },
    { name: "Florescent green", hex: "#51b723", src: null, abrv: "FLGRN" },
    { name: "Green", hex: "#5b982d", src: null, abrv: "GRN" },
    { name: "Mint", hex: "#4cb6ba", src: null, abrv: "MNT" },
    { name: "Light Blue", hex: "#009ec8", src: null, abrv: "LTBLU" },
    { name: "TM Blue", hex: "#0064d4", src: null, abrv: "TMBLU" },
    { name: "Yamaha Blue", hex: "#000489", src: null, abrv: "BLU" },
    { name: "KTM Blue", hex: "#080b48", src: null, abrv: "KTMBLU" },
    { name: "Purple", hex: "#8202be", src: null, abrv: "PURP" },
    // { name: "Purple", hex: "#f827a9", src: null, abrv: "PURP" },
    { name: "Maroon", hex: "#72061f", src: null, abrv: "MRN" },
    { name: "Red", hex: "#ab322a", src: null, abrv: "RED" },
    { name: "Bright Red", hex: "#ea1c10", src: null, abrv: "BRRED" },
    { name: "Orange", hex: "#c9600f", src: null, abrv: "ORG" },
    { name: "Pink", hex: "#c414a5", src: null, abrv: "PNK" },
    { name: "Bright Yellow", hex: "#c1b540", src: null, abrv: "BRYELLOW" },
    { name: "Gold Yellow", hex: "#c99c2a", src: null, abrv: "GOLD" },
    { name: "Yellow", hex: "#bfad3c", src: null, abrv: "YELL" },
    { name: "Neon Yellow", hex: "#b4bc45", src: null, abrv: "NEYELL" },
    { name: "White", hex: "#F5F5F5", src: null, abrv: "WHT" },
  ],
  colorsExcPatterns: 21,
  initialCameraPosition: [2.25, 1, 2.25],
  initialCameraTarget: [0, 0, 0],
  urrentCameraTarget: [-3.25, -1, -3.25],
  cameraTargetLogo: [3, 3, 3],
  currentCameraMode: "FREE",
  fonts: ["impact", "hauser", "comicSans", "oldEnglish"],

  cameraControls: {
    position: [3.5, 1, 1],
    target: [0, 0, 0],
    fov: 10,
    // static: false,
  },
  autoCamera: true,
  cartContentsOpen: false,
  cartContentNumber: 0,
  prices: {
    basePrice: {
      motorcycle: 69.95,
      atv: 74.95,
      scooter: 69.95,
      ebike1: 64.95,
      ebike2: 64.95,
    },
    addonPrice: {
      reinforcedSides: 9.95,
      number: 9.95,
      sealant: 23,
      ribs: 10,
    },
  },
  modal: {
    open: true,
    bottomAlign: false,
    clearBackground: false,
    instructions: false,
    disclaimer: false,
    resetCustomisation: false,
    exitApp: false,
    cameraControls: false,
    orderSummary: false,
    emptyCart: false,
    selectModel: true,
    orderConfirmed: false,
    multiRib: false,
    settingNumber: false,
  },
  scrollPositions: {},
  status: {
    settingReinforcedSides: false,
    confirmLeave: false,
    confirmResetDesign: false,
    confirmResetModel: false,
    productBeingAdded: false,
    confirmResetRibs: false,
    currentRib: 1,
    confirmRemoveNumber: false,
    numberSelectMode: "number",
    termsChecked: false,
    terms2Checked: false,
    cartContentNumber: 0,
  },
});

export { enjoySettings };

// cameraPosition: [1.5, .3 , 1.5]

// stitchColorMode: "no",

// sealantMode: "no",
// message: "",
// customizeModelChoice: false,
// modalOpen: false,
// pendingTransaction: true,
// productBeingAdded: false,
// processingTransaction: false,
// instructionsVisible: false,
// modalResetCustomisationOpen: false,
// exitAppOpen: false,
// cameraControlsOpen: false,
// settingModelType: false,
// settingModel: true,
// modalDisclaimerOpen: false,
// settingMultiRibs: false,
// settingNumber: false,
// termsChecked: false,
// terms2Checked: false,
// confirmResetRibs: false,
// confirmRemoveNumber: false,
// confirmLeave: false,
// confirmReset: false,
// confirmRepick: false,
